import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';

export default function HOSLogo({ className = '' }) {
  const { settings } = useSiteSettings();
  const src = settings.logoUrl || '/logo.png';
  return (
    <img
      src={src}
      alt={settings.siteName || 'House of Sample'}
      className={`h-10 md:h-12 lg:h-14 w-auto object-contain hover:scale-105 transition-transform duration-300 mix-blend-multiply ${className}`}
    />
  );
}
